module.exports = __webpack_public_path__ + "img/yuanchuanxiaobiao.d54f3c23.svg";